/**
 * Atelier Nº7 (QC-01) — aligne les cartes produit d'une même rangée.
 * Les noms de carte (.n7-card-name : modèle + descriptif) n'ont pas tous le même nombre de lignes ;
 * on donne à chaque nom la hauteur du plus haut de sa rangée pour que pastilles, prix et livraison
 * tombent à la même hauteur, sans couper le texte.
 */

let scheduled = false;

function align() {
  scheduled = false;
  const names = Array.from(document.querySelectorAll('.n7-card-name'));
  for (const name of names) if (name instanceof HTMLElement) name.style.minHeight = '';

  /** @type {Map<Element, Map<number, HTMLElement[]>>} */
  const rows = new Map();
  for (const name of names) {
    if (!(name instanceof HTMLElement) || !name.offsetParent) continue;
    const card = name.closest('product-card') ?? name;
    const grid = card.parentElement?.parentElement ?? document.body;
    const top = Math.round(card.getBoundingClientRect().top);
    if (!rows.has(grid)) rows.set(grid, new Map());
    const byTop = rows.get(grid);
    if (!byTop) continue;
    const key = [...byTop.keys()].find((k) => Math.abs(k - top) < 4) ?? top;
    const row = byTop.get(key) ?? [];
    row.push(name);
    byTop.set(key, row);
  }

  for (const byTop of rows.values()) {
    for (const row of byTop.values()) {
      if (row.length < 2) continue;
      const max = Math.max(...row.map((el) => el.offsetHeight));
      for (const el of row) if (el.offsetHeight < max) el.style.minHeight = `${max}px`;
    }
  }
}

function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(align);
}

if (!document.documentElement.dataset.n7CardAlign) {
  document.documentElement.dataset.n7CardAlign = 'on';
  schedule();
  window.addEventListener('resize', schedule);
  document.fonts?.ready.then(schedule);
  // cartes ajoutées après coup (filtres, pagination, recommandations)
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}
